// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2Pg2P","card":"styles_card__2UVwD"};